import React from 'react'
import { getTraitTranslation } from 'components/modals/TestsReportModal/tabs/helpers'
import { TRAITS } from 'components/common/ScoreCard/ScoreCard'
import { formatTimeVerbose } from 'utils/stringFormat'

const useFactorData = ({ traits }) => {
  const [attributes, setAttributes] = React.useState(
    Object.fromEntries(traits.map(key => [key, false])),
  )

  const isAllOpened = React.useMemo(
    () => Object.values(attributes).every(value => value === true),
    [attributes],
  )

  const handleToggle = React.useCallback(trait => {
    setAttributes(attributes => ({
      ...attributes,
      [trait]: !attributes[trait],
    }))
  }, [])

  const handleToggleAll = React.useCallback(() => {
    setAttributes(attributes => {
      if (isAllOpened) {
        return Object.fromEntries(
          Object.keys(attributes).map(key => [key, false]),
        )
      }

      if (!isAllOpened) {
        return Object.fromEntries(
          Object.keys(attributes).map(key => [key, true]),
        )
      }

      return attributes
    })
  }, [isAllOpened])

  return {
    state: { attributes, isAllOpened },
    handlers: { handleToggle, handleToggleAll },
  }
}

export const useFactorState = state => {
  const { factor, language, scores, stats } = state

  const { correct, seconds, totalAnswers, totalQuestions } = stats ?? {}

  const score = scores?.[factor]

  const {
    label,
    abstract = [],
    description = [],
  } = getTraitTranslation(factor, score, language)

  const traits = TRAITS[factor]

  const traitsCount = traits.length

  const time = formatTimeVerbose(seconds)

  const {
    state: { attributes, isAllOpened },
    handlers: { handleToggle, handleToggleAll },
  } = useFactorData({ traits })

  return {
    state: {
      abstract,
      attributes,
      correct,
      description,
      label,
      score,
      time,
      totalAnswers,
      totalQuestions,
      traits,
      traitsCount,
      isAllOpened,
    },
    handlers: { handleToggle, handleToggleAll },
  }
}
